<template>
  <div class="visitor ui-container">
    <div class="logos">
      <img src="/img/visitor/hj-comunidades.png" alt="" />
      <img class="logo_a9" src="/img/visitor/marca-a9.png" alt="" />
      <!-- <img src="/img/visitor/chamada.png" alt="" /> -->
    </div>
    <form @submit.prevent="enviaForm()" class="form_inputs">
      <div class="input_conjunto">
        <input class="input" type="text" placeholder="Seu nome:" required v-model="visitante.name" />
        <input class="input" type="text" placeholder="Seu sobrenome:" required v-model="visitante.surname" />
      </div>
      <input class="input" type="email" placeholder="Seu melhor e-mail:" required v-model="visitante.email" />
      <div class="input_conjunto">
        <input v-mask="['###.###.###-##']" class="input" type="text" required placeholder="Seu CPF:" v-model="visitante.cpf" />
        <input v-mask="['(##) #####-####', '(##) ####-####']" required class="input" type="text" placeholder="Telefone:" v-model="visitante.phone" />
      </div>
      <input class="input" type="text" placeholder="Cidade:" required v-model="visitante.city" />
      <input class="input" type="text" placeholder="Empresa:" required v-model="visitante.company" />
      <input class="input" type="text" placeholder="Seu Cargo:" required v-model="visitante.position" />
      <!-- <select class="input" v-model="visitante.range_of_employees" placeholder="">
        <option style="color: gray" value="" selected disabled>Número de Funcionários:</option>
        <option :value="0">Até 10 colaboradores</option>
        <option :value="1">De 10 a 50 colaboradores</option>
        <option :value="2">De 51 a 100 colaboradores</option>
        <option :value="3">De 101 a 1.000 colaboradores</option>
        <option :value="4">Acima de 1.000 colaboradores</option>
      </select> -->
      <!-- <select class="input" v-model="visitante.annual_billing" placeholder="">
        <option style="color: gray" value="" selected disabled>Faturamento Anual:</option>
        <option :value="0">Ainda não faturamos</option>
        <option :value="1">Até R$500 mil ao ano</option>
        <option :value="2">De R$500 a R$1 milhão</option>
        <option :value="3">De R$1 a R$5 milhões</option>
        <option :value="4">De R$5 a R$10 milhões</option>
        <option :value="5">De R$10 a R$50 milhões</option>
        <option :value="6">De R$50 a R$500 milhões</option>
        <option :value="7">Acima de R$500 milhões</option>
      </select> -->
      <div class="input_conjunto">
        <div class="input_radio">
          <label>Costuma participar de eventos corporativos?</label>
          <div>
            <div class="radio">
              <input v-model="visitante.usually_participate" :value="true" type="radio" />
              <label>Sim</label>
            </div>
            <div class="radio">
              <input v-model="visitante.usually_participate" :value="false" type="radio" />
              <label>Não</label>
            </div>
          </div>
        </div>
        <div class="input_radio">
          <label>Já conhecia o <strong>HJ Conference?</strong></label>
          <div>
            <div class="radio">
              <input v-model="visitante.already_know" :value="true" type="radio" />
              <label>Sim</label>
            </div>
            <div class="radio">
              <input v-model="visitante.already_know" :value="false" type="radio" />
              <label>Não</label>
            </div>
          </div>
        </div>
      </div>
      <div class="input_check">
        <div class="box_check">
          <input v-model="visitante.privacy_policy" required type="checkbox" />
          <label></label>
        </div>
        <a href="https://drive.google.com/file/d/1ohqGeUygr3234Xouk4-23ocjzvHSZuRW/view" target="_blank">Eu aceito a Política de Privacidade</a>
      </div>
      <div class="btn_envio">
        <button type="submit">{{ btn_text }}</button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["apiEndpoint"],
  data() {
    return {
      visitante: {
        name: "",
        surname: "",
        cpf: "",
        email: "",
        phone: "",
        company: "",
        city: "",
        position: "",
        // range_of_employees: "",
        // annual_billing: "",
        usually_participate: false,
        already_know: false,
        privacy_policy: false,
      },
      btn_text: "Entrar na Lista",
    };
  },
  methods: {
    async enviaForm() {
      console.log(`aaa`)
      this.btn_text = "Confirmando...";
      let url = this.apiEndpoint;

      if (!this.visitante.privacy_policy) {
        alert(`Você precisa aceitar a Política de Privacidade`);
        this.btn_text = "Entrar na Lista";
        return false
      }
      let keys = Object.keys(this.visitante);
      let filtro = false;

      // keys.filter((key) => {
      //   if (this.visitante[key] === "" && !filtro) {
      //     alert(`Você precisa preencher todos os campos`);
      //     this.btn_text = "Entrar na Lista";
      //     filtro = true;
      //   } else if (key === "privacy_policy" && !this.visitante.privacy_policy && !filtro) {
      //     alert(`Você precisa aceitar a Política de Privacidade`);
      //     this.btn_text = "Entrar na Lista";
      //     filtro = true;
      //   }
      // });
      if (!filtro) {
        await axios
          .post(url, this.visitante)
          .then((res) => {
            this.btn_text = "Confirmado!";
            this.visitante = {
              name: "",
              surname: "",
              cpf: "",
              email: "",
              phone: "",
              company: "",
              city: "",
              position: "",
              // range_of_employees: "",
              // annual_billing: "",
              usually_participate: false,
              already_know: false,
              privacy_policy: false,
            };
            alert(`Seu lugar está garantido!`);
          })
          .catch((err) => {
            console.log(err.response);
            alert(`Não foi possível realizar o seu credenciamento, contate um dos nossos Staffs`);
          })
          .finally(() => {
            this.btn_text = "Entrar na Lista";
          });
      }
    },
  },
};
</script>
<style lang="scss">
</style>